import * as React from "react";

import connectToList from "../../store/list";

import GenMore from "../Gen/More";

import DocumentSetDocumentRelationSummary from "../DocumentSetDocumentRelation/Summary";

import DocumentListControls from "../Document/ListControls";
interface DocumentSetDocumentRelationListProps {
  document_set: DocumentSetSnakeModel
  isLearner: boolean;
  show_status: boolean;
  documentSetDocumentRelations: ConnectedList<DocumentSetDocumentRelationSnakeModel>;
}

function DocumentSetDocumentRelationList(props: DocumentSetDocumentRelationListProps) {
  const {
    document_set,
    isLearner,
    show_status,
    documentSetDocumentRelations,
  } = props;

  React.useEffect(() => {
    documentSetDocumentRelations.mountList(`/document_sets/${document_set.id}/document_set_document_relations`);
  }, []);

  return(
    <div>
      <DocumentListControls
        documents={documentSetDocumentRelations}
      />
      <div className="gen-list-grid">
        {
          documentSetDocumentRelations.listData?.map((documentSetDocumentRelation) => (
            <DocumentSetDocumentRelationSummary
              key={documentSetDocumentRelation.id}
              documentSetDocumentRelation={documentSetDocumentRelation}
              show_status={show_status}
              isLearner={isLearner}
              documentSet={document_set}
            />
          ))
        }
      </div>
      <GenMore
        {...documentSetDocumentRelations}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(DocumentSetDocumentRelationList, ["documentSetDocumentRelations"]);
